define(
    'services/config',[
        "durandal/system",
        "durandal/app",
        "plugins/dialog",
        "durandal/binder",
        "durandal/viewLocator",
        "services/log",
        "plugins/router",
        "dropzone"
        //"toastr",
        //"i19n!i19n/strings", // loads in the ko.validation localizations        
    ],
    function (system, app, dialog, binder, viewLocator, log, router, Dropzone) { //, toastr

        var events;
        var delays = (function (multiplier) {
                        return {
                            fastest: 1 * multiplier,
                            fast: 3 * multiplier,
                            average: 5 * multiplier,
                            slow: 10 * multiplier,
                            slowest: 30 * multiplier,
                            infinite: 3 * 60 * multiplier
                        };
                    })(100);
        var childRoutes = null;
        var maxFilesizeUpload = 2048; // MB

        function buildChildRoutes() {
            var d = $.Deferred();
        
            if (childRoutes) {
                d.resolve(childRoutes);
            } else {
                require(["services/session"], function (session) {
                    childRoutes = _buildChildRoutes(session);

                    d.resolve(childRoutes);
                });
            }

            return d.promise();            
        }
        function _buildChildRoutes(session) {
            return [
                    { route: ["explorer", ""],                      moduleId: "explorer/explorer",          title: 'Explorer',                  display: session.isAuthenticated,   settings: { showToggles: true } },
                    { route: "explorer/:type",                      moduleId: "explorer/explorer",          title: 'Explorer',                  display: session.isAuthenticated,   settings: { showToggles: true } },
                    { route: "explorer/:type/:id",                  moduleId: "explorer/explorer",          title: 'Explorer',                  display: session.isAuthenticated,   settings: { showToggles: true } },
                    { route: "explorer/:type/:id/:id",              moduleId: "explorer/explorer",          title: 'Explorer',                  display: session.isAuthenticated,   settings: { showToggles: true } },
                    { route: "explorer/:type/:id/:id/:id",          moduleId: "explorer/explorer",          title: 'Explorer',                  display: session.isAuthenticated,   settings: { showToggles: true } },
                    { route: "explorer/:type/:id/:id/:id/:id",      moduleId: "explorer/explorer",          title: 'Explorer',                  display: session.isAuthenticated,   settings: { showToggles: true } },

                    { route: "plan/:id",                moduleId: "subscription/plan",          title: 'Plan',                      display: session.isAuthenticated },
                    { route: "pricing/:id",             moduleId: "subscription/pricing",       title: 'Pricing',                   display: session.isAuthenticated },
                    { route: ["libraries", "libraries/:id"], moduleId: "libraries/libraries",   title: 'Libraries',                 display: session.isAuthenticated },
                    { route: "lists",                   moduleId: "lists/lists",                title: 'Lists',                     display: session.isAuthenticated },
                    { route: "people",                  moduleId: "people/people",              title: 'People',                    display: session.isAuthenticated },                    
                    //{ route: "account",                 moduleId: "account/account",            title: 'Account',                   display: session.isAuthenticated },
                    { route: "change",                  moduleId: "account/change",             title: 'Change Password',           display: session.isAuthenticated },
                    { route: "help",                    moduleId: "help/help",                  title: 'Help',                      display: session.isAuthenticated },
                    { route: "settings",                moduleId: "settings/settings",          title: 'Settings',                  display: session.isAuthenticated },
                    { route: "shares/:id",              moduleId: "shares/share",               title: 'Document Shares',           display: session.isAuthenticated },
                    { route: "sharedetails/:id",        moduleId: "shares/sharedetails",        title: 'Document Share Details',    display: session.isAuthenticated },
                    { route: "uploads/:m",              moduleId: "uploads/upload",             title: 'Upload Request',            display: session.isAuthenticated },
                    { route: "uploaddetails/:m",        moduleId: "uploads/uploaddetails",      title: 'Upload Request Details',    display: session.isAuthenticated },
                    { route: "settingsUsage",           moduleId: "settings/settings",          title: 'Settings',                  display: session.isAuthenticated },

                    { route: "actionsModifyfield",      moduleId: "explorer/details/tabs/actions/actionsModifyfield/actionsModifyfield",            title: 'Modify Field',          display: session.isAuthenticated },
                    { route: "actionsReplaceFile",      moduleId: "explorer/details/tabs/actions/actionsReplaceFile/actionsReplaceFile",            title: 'Replace File',          display: session.isAuthenticated },
                    { route: "actionsCheckIn",          moduleId: "explorer/details/tabs/actions/actionsCheckIn/actionsCheckIn",                    title: 'Check In',              display: session.isAuthenticated },
                    { route: "actionsAddDocument",      moduleId: "explorer/details/tabs/actions/actionsAddDocument/actionsAddDocument",            title: 'Add Document',          display: session.isAuthenticated },
                    { route: "actionsAddTemplate",      moduleId: "explorer/details/tabs/actions/actionsAddTemplate/actionsAddTemplate",            title: 'Add Template',          display: session.isAuthenticated },
                    { route: "actionsUploadRequest",    moduleId: "explorer/details/tabs/actions/actionsUploadRequest/actionsUploadRequest",        title: 'Upload Request',        display: session.isAuthenticated },
                    { route: "actionsUploadAsVersion",  moduleId: "explorer/details/tabs/actions/actionsUploadAsVersion/actionsUploadAsVersion",    title: 'Add Document',          display: session.isAuthenticated },
                    { route: "actionsShare",            moduleId: "explorer/details/tabs/actions/actionsShare/actionsShare",                        title: 'Share',                 display: session.isAuthenticated },
                    { route: "actionsDocumentLinks",    moduleId: "explorer/details/tabs/actions/actionsDocumentLinks/actionsDocumentLinks",        title: 'Document Links',        display: session.isAuthenticated }
            ];
        }

        function initRouter() {            
            router.guardRoute = function (moduleInstance, routeInfo) {

                var d = $.Deferred();

                if (routeInfo.config.route == '') {
                    d.resolve("#login");

                    return d.promise();
                }

                require(['viewmodels/controller', 'services/session'], function (shell, session) {

                    var Sequence = function () {
                        this.serverStatus = function (c) {
                            var self = this;

                            this.serverStatus.d = $.Deferred();

                            session
                            .getServerStatus()
                            .done(function (status) {
                                self.serverStatus.d.resolve(status);
                                c(status);
                            })
                            .fail(function () {
                                self.serverStatus.d.resolve(true);
                                c(true);
                            });

                            return self;
                        };
                        this.instanceCodeStatus = function (c) {
                            var self = this;

                            this.instanceCodeStatus.d = $.Deferred();

                            this.serverStatus.d.promise()
                            .done(function (r) {
                                if (!r) {
                                    session
                                    .getInstanceCodeStatus()
                                    .done(function (status) {                                        
                                        self.instanceCodeStatus.d.resolve(status);
                                        c(status);
                                    })
                                    .fail(function () {
                                        self.instanceCodeStatus.d.resolve(true);
                                        c(true);
                                    });
                                }
                            });

                            return self;
                        };
                        this.subscriptionStatus = function (c) {
                            var self = this;

                            this.subscriptionStatus.d = $.Deferred();

                            this.instanceCodeStatus.d.promise()
                            .done(function (r) {
                                if (!r) {
                                    session
                                    .getSubscriptionStatus()
                                    .done(function (status) {
                                        self.subscriptionStatus.d.resolve(status);
                                        c(status);
                                    })
                                    .fail(function () {
                                        self.subscriptionStatus.d.resolve(true);
                                        c(true);
                                    });
                                }
                            });

                            return self;
                        };
                        this.always = function (c) {
                            var self = this;
                            
                            this.subscriptionStatus.d.promise()
                            .done(function (r) {
                                if (!r) {
                                    c(false);
                                }
                            });

                            return this;
                        };
                    };                    

                    if (routeInfo.config.route == "status/:id") {
                        new Sequence()
                        .serverStatus(function (r) {
                            if (r) {
                                if (routeInfo.fragment != 'status/id=1')
                                    d.resolve('#status/id=1');
                                else
                                    d.resolve(true);
                            }
                        })
                        .instanceCodeStatus(function (r) {
                            if (r) {
                                if (routeInfo.fragment != 'status/id=2')
                                    d.resolve('#status/id=2');
                                else                                    
                                    d.resolve(true);
                            }
                        })
                        .subscriptionStatus(function (r) {
                            if (r) {
                                if (routeInfo.fragment != 'status/id=3')
                                    d.resolve('#status/id=3');
                                else
                                    d.resolve(true);
                            }
                        })                  
                        .always(function () {                            
                            _navigate('Login', 1000);
                            
                            d.resolve("#login");
                        });
                    } else {
                        
                        new Sequence()
                        .serverStatus(function (r) {
                            if (r) {
                                d.resolve(false);
                                router.navigate('#status/id=1');
                            }
                        })
                        .instanceCodeStatus(function (r) {                            
                            if (r) {
                                d.resolve(false);
                                router.navigate('#status/id=2');
                            }
                        })
                        .subscriptionStatus(function (r) {
                            if (r) {
                                d.resolve(false);
                                router.navigate('#status/id=3');
                            }
                        })
                        .always(function () {
                            proceedToRoute();
                        });
                    }

                    function proceedToRoute() {
                        //if (routeInfo.config.route == '') {
                        //    d.resolve("#login");
                        //    return;
                        //}

                        if (isPublicRoute()) {
                            if (sessionStorage.navto) {
                                if (sessionStorage.navto == "login" || sessionStorage.navto == "logout") {
                                    sessionStorage.removeItem("navto");
                                }
                            }

                            d.resolve(true);

                        } else {
                            var rs = childRoutes == null ? _buildChildRoutes({ isAuthenticated: false }) : childRoutes;
                            var r = _.find(rs, function (itm) { return itm.route == routeInfo.fragment; });

                            if (r) _navigate(r.title, 1500);
                            
                            session
                            .validateLogin()
                            .done(function (isLoggedIn) {
                                shell.isNavigating(false);
                                
                                if (isLoggedIn) {
                                    
                                    session.getIsSuspended()
                                    .done(function (isSuspended) {
                                        
                                        if (isSuspended) {
                                            if (routeInfo.config.route != "suspended" &&
                                                routeInfo.fragment != "plan/0" &&
                                                routeInfo.fragment != "plan/1") {
                                               
                                                d.resolve("#suspended");
                                                window.location.hash = "#suspended";
                                                window.location.reload(true);
                                            } else {
                                                d.resolve(true);
                                            }
                                            
                                        } else {
                                            if (routeInfo.config.route == "suspended") {
                                                d.resolve("#explorer");
                                                window.location.hash = "#explorer";
                                                window.location.reload(true);
                                            }
                                            
                                            if (routeInfo.config.route == "") {
                                                d.resolve("#explorer");
                                            } else {
                                                d.resolve(true);
                                            }
                                        }
                                    })
                                    .fail(function (e) {
                                    });

                                } else {
                                    sessionStorage.navto = routeInfo.fragment;
                                    
                                    d.resolve("#login");
                                }
                            })
                            .fail(function () {
                                sessionStorage.removeItem("navto");

                                d.resolve("#login");
                            });
                        }

                        function isPublicRoute() {
                            return routeInfo.config.route == "upload/:id" || routeInfo.config.route == "trialcancelled" || routeInfo.config.route == "logout" || routeInfo.config.route == "login" || routeInfo.config.route == "reset/:id" || routeInfo.config.route == "shared/:id" || routeInfo.config.route == "status/:id";
                        }
                    }
                    function _navigate(title, delay) {
                        shell.isNavigating(true, title);

                        setTimeout(function () {
                            shell.isNavigating(false);
                        }, delay);
                    }
                });

                return d.promise();                
            };

            router.displayRoutes = ko.computed(function () {
                return router.routes.filter(function (route) {
                    return route.display();
                });
            });
        }

        function initToastr() {
            toastr.options.timeOut = 4000;
            toastr.options.positionClass = "toast-top-right";
        }

        function initValidation() {
            ko.validation.configure({
                registerExtenders: true,    //default is true
                messagesOnModified: true,   //default is true
                insertMessages: true,       //default is true
                //parseInputAttributes: true, //default: is false 
                writeInputAttributes: true, //default is false
                messageTemplate: null,      //default is null
                decorateElement: true       //default is false. Applies the .validationElement CSS class
            });

//            // this override is a result of this bug I found: https://github.com/Knockout-Contrib/Knockout-Validation/issues/277
//            // note: setting this to true and having writeInputAttributes set to true, causes a conflict. 
//            // this line in the knockout.validation.js - executes at the wrong time or something - async(function () { exports.parseInputValidationAttributes(element, valueAccessor); });
//            ko.validation.addRule = function (observable, rule) {
//                if (!ko.validation.utils.isValidatable(observable))
//                    observable.extend({ validatable: true });
//
//                var hasRule;
//                ko.utils.arrayForEach(observable.rules(), function (arrRule) {
//                    if (arrRule.name == rule.name) {
//                        hasRule = true;
//                        return;
//                    }
//                });
//
//                if (!hasRule) {
//                    //push a Rule Context to the observables local array of Rule Contexts
//                    observable.rules.push(rule);
//                }
//                return observable;
//            };

        }

        function initEvents() {
            events = {
                header: {
                    show: "header:show"
                },
                explorer: {
                    layout: {
                        toggleNavigation: "explorer:toggleNavigation",
                        toggleDetails: "explorer:toggleDetails",                        

                        resizedNavigationPane: "explorer:resizedNavigationPane",
                        resizedResultsPane: "explorer:resizedResultsPane",
                        resizedDetailsPane: "explorer:resizedDetailsPane"
                    },
                    results: {
                        filterby: "explorer:results.filterby",
                        kendoGridRowUpdateColumn: "explorer:results.kendoGridRowUpdateColumn",
                        kendoGridColumnManage: "explorer:results.kendoGridColumnManage",
                        kendoGridRowMarkDirty: "explorer:results.kendoGridRowMarkDirty",
                        dropzoneShow: "explorer:results.dropzoneShow"
                    },
                    navigation: {
                        refresh: "explorer:navigation.refresh",
                        checkoutCount: "explorer:navigation.checkoutCount"
                    }
                },
                errors: {
                    ajax: "errors:ajax",
                    serverException: "errors:serverException"
                }
            };
        }

        function initLog() {

            binder.throwOnErrors = true;
            requirejs.onError = log.error;
            system.error = log.error;

            log.showTimestamps = true;
            log.addType("event", "purple", "log");
            log.addType("data", "orange", "log");
            system.log = log.addType("system", "green", "log"); // reassigning the system.logger to custom logger. this replaces -> system.debug(true);
            log.off("data");
            log.off("event");
            log.on("system");

            log.addType("canDeactivate", "blue", "log");
            log.addType("canActivate", "blue", "log");
            log.addType("deactivate", "blue", "log");
            log.addType("activate", "blue", "log");
            log.addType("binding", "blue", "log");
            log.addType("bindingComplete", "blue", "log");
            log.addType("attached", "blue", "log");
            log.addType("compositionComplete", "blue", "log");
            log.addType("detached", "blue", "log");

            log.off("canDeactivate", "canActivate", "activate", "deactivate", "binding", "bindingComplete", "attached", "compositionComplete", "detached");
        }

        function initPlugins() {

            //specify which plugins to install and their configuration
            app.configurePlugins({
                router: true,
                dialog: true,
                widget: {
                    kinds: [
                        'document_results_heading',
                        'form_text_field',
                        'form_number_field',
                        'form_date_field',
                        'form_combobox',
                        'form_checkbox',
                        'fp_list_maintenance_grid',
                        'fp_form_addpeople',
                        'fp_treeview_folder',
                        'fp_form_addfdocuments',
                        'fp_accesscontrol'
                    ]
                }
            });
        }

        function initViewLocator() {
            viewLocator.useConvention();
            var baseConverter = viewLocator.convertModuleIdToViewId;
            viewLocator.convertModuleIdToViewId = function (moduleId) {
                if (moduleId.toLowerCase().indexOf("modals") == 0) {
                    return moduleId;
                }
                return baseConverter(moduleId);
            };
        }

        function initDropzone() {
            Dropzone.autoDiscover = false;
        }

        function init() {
            initRouter();
            initViewLocator();
            initToastr();
            initValidation();
            initLog();
            initEvents();
            initPlugins();
            initDropzone();
        }

        init();        
        
        return {
            webApiUrl: window.fileplan.webApiUrl,
            instanceCode: window.fileplan.instanceCode,
            delays: delays,
            events: events,
            buildChildRoutes: buildChildRoutes,
            maxFilesizeUpload: maxFilesizeUpload
        };
    });
